"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterWeavesByStatus = filterWeavesByStatus;
exports.filterWeavesByPhase = filterWeavesByPhase;
exports.filterWeavesById = filterWeavesById;
const derived_1 = require("../derived");
/**
 * Filters an array of weaves by their derived status.
 */
function filterWeavesByStatus(weaves, statuses) {
    return weaves.filter(w => statuses.includes((0, derived_1.getWeaveStatus)(w)));
}
/**
 * Filters an array of weaves by their derived phase.
 */
function filterWeavesByPhase(weaves, phases) {
    return weaves.filter(w => phases.includes((0, derived_1.getWeavePhase)(w)));
}
/**
 * Filters an array of weaves by a pattern matched against their ID.
 */
function filterWeavesById(weaves, pattern) {
    const regex = new RegExp(pattern, 'i');
    return weaves.filter(w => regex.test(w.id));
}
